module.exports = __webpack_public_path__ + "static/media/documentUpload.c8df3ffc.svg";